import type { ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "danger" | "ghost";
  size?: "sm" | "md";
}

const VARIANT: Record<NonNullable<ButtonProps["variant"]>, string> = {
  primary:
    "bg-[var(--color-accent)] text-white hover:bg-[var(--color-accent-light)] disabled:opacity-50",
  secondary:
    "bg-[var(--color-elevated)] text-[var(--color-text)] border border-[var(--color-border)] hover:border-[var(--color-border-hover)] disabled:opacity-50",
  danger:
    "bg-[rgba(237,66,69,0.15)] text-[var(--color-error)] border border-[rgba(237,66,69,0.3)] hover:bg-[rgba(237,66,69,0.25)] disabled:opacity-50",
  ghost:
    "text-[var(--color-text-muted)] hover:text-[var(--color-text)] hover:bg-[var(--color-elevated)] disabled:opacity-50",
};

export function Button({
  variant = "primary",
  size = "md",
  className = "",
  ...rest
}: ButtonProps) {
  const sizeClass = size === "sm" ? "px-3 py-1.5 text-xs" : "px-4 py-2 text-sm";
  return (
    <button
      className={[
        "inline-flex items-center gap-2 rounded-md font-medium transition-colors disabled:cursor-not-allowed",
        sizeClass,
        VARIANT[variant],
        className,
      ].join(" ")}
      {...rest}
    />
  );
}
